"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchLoupeIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.SearchLoupeIcon24Regular = forwardRef_1.forwardRef('SearchLoupeIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.995 1.503a9.492 9.492 0 0 0 0 18.984 9.455 9.455 0 0 0 6.161-2.27l4.326 4.326a.75.75 0 1 0 1.06-1.06l-4.325-4.327a9.455 9.455 0 0 0 2.27-6.16 9.492 9.492 0 0 0-9.492-9.493Zm-7.992 9.492a7.992 7.992 0 1 1 15.985 0 7.992 7.992 0 0 1-15.985 0Z" })));
});
